import _extends from "@babel/runtime/helpers/esm/extends";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
function RichTextEditor(props) {
  const [dynamic, setDynamic] = useState(null);
  useEffect(() => {
    const loadDynamic = () => __awaiter(this, void 0, void 0, function* () {
      const x = yield import('./RichText');
      setDynamic(x);
    });
    loadDynamic();
  }, []);
  if (!dynamic) {
    return _jsx(_Fragment, {});
  }
  return _jsx(dynamic["default"], _extends({}, props));
}
export default RichTextEditor;